export const FALLBACK_ICON_SIZE = 50;
export const NORMAL_MAX_WIDTH = 300;
export const NORMAL_MIN_WIDTH = 170;
export const NORMAL_HEIGHT = 34;
export const SIDES_SPACING = 30;
export const ROUNDING = 30;
export const OUTLINE_BORDER_WIDTH = 2;
export const ROUND_DEF_SIZE = 39;
export const ICON_DEF_PADDING = 2;
